import { useQuery } from "@tanstack/react-query";
import { DocumentLinkService } from "../../../services/document/document-link.service";
import { useMemo } from "react";
import { getDiffDay } from "../../../helper/dateTimeHelper";
import { useDocumentType } from "../../document/hooks/documents/use-document-type";

const isDocumentExpired = (effectiveTo: string) => {
  const today = new Date();
  return getDiffDay(effectiveTo, today.toDateString()) >= 0;
};

export const useDocumentLink = () => {
  const { data: docTypeData } = useDocumentType();
  const { data, isLoading } = useQuery({
    queryKey: ["document-link-info"],
    queryFn: () => DocumentLinkService.getListDocumentLinkInfos(),
  });

  const needProcessDocument = useMemo(() => {
    const filteredDocuments = data?.data.filter((e: any) => isDocumentExpired(e.docLinkExpiredDate) && !e.isDeleted);

    const uniqueDocuments = Array.from(new Set(filteredDocuments?.map((doc: any) => doc.docFileId))).map(
      (docFileId: any) => filteredDocuments.find((doc: any) => doc.docFileId === docFileId),
    );

    return uniqueDocuments;
  }, [data?.data]);

  const mappedNeedProcessDocument = useMemo(
    () =>
      needProcessDocument?.map((e: any) => ({
        Title: e.Title,
        docTypeId: e.docLinkTypeId,
        docType: docTypeData?.find((docType: any) => docType.value === e.docTypeId)?.label,
        listItemId: e.docId,
        id: e.docFileId,
        docUrl: e.docLinkUrl,
        docStatus: "Cần xử lý",
      })),
    [docTypeData, needProcessDocument],
  );

  const countNeedProcessDocument = useMemo(() => needProcessDocument?.length, [needProcessDocument?.length]);

  const shortDocumentLinkData = useMemo(
    () => data?.data.filter((e: any) => e.docTypeId === "2" && e.docLinkTypeId === "1"),
    [data?.data],
  );

  return {
    data,
    isLoading,
    needProcessDocument,
    countNeedProcessDocument,
    mappedNeedProcessDocument,
    shortDocumentLinkData,
  };
};
